module.exports = __webpack_public_path__ + "static/about-us-hero-14dc9f30351b585779638ac0cedf2423.png";